import React from 'react'
import { Link } from 'react-router-dom'
import { CheckIcon } from '@heroicons/react/20/solid'

export default function Home() {
  const features = [
    {
      title: 'Easy Folder Selection',
      description: 'Simply select your image folders and let Snappy Slides handle the rest'
    },
    {
      title: 'Dual Image Display',
      description: 'Show two images side by side for perfect comparison and storytelling'
    },
    {
      title: 'Automatic Transitions',
      description: 'Smooth transitions between images with customizable timing'
    },
    {
      title: 'Cross-Platform',
      description: 'Works seamlessly on both Windows and macOS'
    },
    {
      title: 'Safe & Secure',
      description: 'Your privacy is our priority. No images or metadata are shared or uploaded to our servers'
    }
  ]

  const supportedFormats = [
    { name: 'JPEG', extension: '.jpg, .jpeg' },
    { name: 'PNG', extension: '.png' },
    { name: 'GIF', extension: '.gif' }
  ]

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-purple-600 via-primary to-accent min-h-[calc(100vh-4rem)]">
      <div className="absolute inset-0 bg-grid-white/[0.2] bg-[length:20px_20px]" />
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-8 leading-tight">
              Snappy Slides
              <br /><br />
              <span className="text-accent">Simple slideshows in minutes</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-12 leading-relaxed">
              Create simple single or dual-image slideshow for your next birthday party, wedding event or just something fun to show off.
            </p>
            
            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {features.slice(0, 4).map((feature, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-left">
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <CheckIcon className="h-6 w-6 text-accent" aria-hidden="true" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-white">{feature.title}</h3>
                      <p className="mt-1 text-white/80">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Safe & Secure and Supported Formats Row */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {/* Safe & Secure Feature */}
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-left">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <CheckIcon className="h-6 w-6 text-accent" aria-hidden="true" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-white">{features[4].title}</h3>
                    <p className="mt-1 text-white/80">{features[4].description}</p>
                  </div>
                </div>
              </div>

              {/* Supported Formats */}
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-left">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <CheckIcon className="h-6 w-6 text-accent" aria-hidden="true" />
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-semibold text-white">Supported Image Formats</h3>
                    <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
                      {supportedFormats.map((format, index) => (
                        <div key={index} className="bg-white/5 rounded-lg p-4 text-center">
                          <span className="text-accent font-medium">{format.name}</span>
                          <p className="text-white/80 text-sm mt-1">{format.extension}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              <Link 
                to="/Slideshow" 
                className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-md text-primary bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white/50 transition-all duration-200 shadow-lg"
              >
                Create Slideshow
                <svg className="ml-2 -mr-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 